import type { KeyboardEvent } from "react";

export function preventSubmitOnEnter(e: KeyboardEvent<HTMLFormElement>): void {
  const { key, target } = e;

  if (key !== "Enter" || target instanceof HTMLTextAreaElement) {
    return;
  }

  e.preventDefault();
}
